// Offer Intelligence mock dataset.

export const propertyHero = {
  address: "14 Riverlight Quay",
  city: "London",
  postcode: "SW11 8DZ",
  asking: "£625,000",
  type: "Apartment · 2 bed · 2 bath · 24th floor",
  image: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=400&q=80&auto=format&fit=crop",
  offers: 4,
  bestOffer: "£630,000",
  bestPremium: "+£5,000",
  avgStrength: 84,
  daysOnMarket: 12,
  viewings: 27,
  reference: "CF-LON-RVQ-014",
};

export const offers = [
  {
    id: "o-001",
    rank: 2,
    buyer: "Akari Tanaka",
    avatarColor: "rose",
    avatarInitials: "AT",
    type: "Cash buyer",
    typeChip: "bg-slate-900 text-white",
    offer: "£620,000",
    offerNum: 620000,
    delta: "-£5,000 vs ask",
    deltaTone: "rose",
    score: 94,
    scoreLabel: "Exceptional",
    chain: "No chain",
    deposit: 100,
    mortgage: "Cash · POF verified",
    mortgageState: "verified",
    solicitor: "Hill Dickinson · instructed",
    solicitorReady: 92,
    pof: "Coutts statement · verified",
    pofReady: 100,
    speed: "21 days",
    fallthrough: 4,
    motivation: 86,
    timeline: "Exchange wk of 27 Mar · complete 10 Apr",
    flags: ["Bank-confirmed funds", "Repeat ChainFlow buyer (3 prior exchanges)"],
    notes: "Investor portfolio — flexible on completion, prefers exchange this month.",
    aiVerdict: "Best overall — speed × certainty",
    highlight: true,
  },
  {
    id: "o-002",
    rank: 1,
    buyer: "Marcus Bellingham",
    avatarColor: "blue",
    avatarInitials: "MB",
    type: "Chain buyer",
    typeChip: "bg-amber-50 text-amber-700 border border-amber-200",
    offer: "£630,000",
    offerNum: 630000,
    delta: "+£5,000 vs ask",
    deltaTone: "emerald",
    score: 76,
    scoreLabel: "Solid",
    chain: "2 deals deep · STC",
    deposit: 35,
    mortgage: "AIP issued · 65% LTV",
    mortgageState: "in_review",
    solicitor: "Brabners LLP · paperwork pending",
    solicitorReady: 56,
    pof: "Awaiting full statement",
    pofReady: 60,
    speed: "48 days",
    fallthrough: 18,
    motivation: 72,
    timeline: "Exchange wk of 24 Apr · complete 15 May",
    flags: ["Chain dependency on St Albans sale", "Higher headline price"],
    notes: "Strong offer but tied to onward chain currently mid-search.",
    aiVerdict: "Highest price, elevated chain risk",
  },
  {
    id: "o-003",
    rank: 3,
    buyer: "Priya & Daniel Chandra",
    avatarColor: "violet",
    avatarInitials: "PC",
    type: "First-time buyers",
    typeChip: "bg-indigo-50 text-indigo-700 border border-indigo-200",
    offer: "£615,000",
    offerNum: 615000,
    delta: "-£10,000 vs ask",
    deltaTone: "rose",
    score: 88,
    scoreLabel: "Strong",
    chain: "No chain · FTB",
    deposit: 25,
    mortgage: "Mortgage offer issued · TMW",
    mortgageState: "offered",
    solicitor: "Slater & Gordon · ready",
    solicitorReady: 88,
    pof: "Halifax statement · verified",
    pofReady: 95,
    speed: "28 days",
    fallthrough: 9,
    motivation: 94,
    timeline: "Exchange wk of 31 Mar · complete 17 Apr",
    flags: ["No chain — clean transaction", "Already had survey arranged"],
    notes: "Highly motivated, formal offer issued, all documentation ready.",
    aiVerdict: "Fastest route at lowest risk",
  },
  {
    id: "o-004",
    rank: 4,
    buyer: "Helena Greaves",
    avatarColor: "amber",
    avatarInitials: "HG",
    type: "Chain buyer",
    typeChip: "bg-amber-50 text-amber-700 border border-amber-200",
    offer: "£600,000",
    offerNum: 600000,
    delta: "-£25,000 vs ask",
    deltaTone: "rose",
    score: 58,
    scoreLabel: "Watch",
    chain: "1 deal deep · pending offer",
    deposit: 20,
    mortgage: "AIP only",
    mortgageState: "in_review",
    solicitor: "Not yet instructed",
    solicitorReady: 14,
    pof: "Pending",
    pofReady: 22,
    speed: "62 days",
    fallthrough: 31,
    motivation: 51,
    timeline: "Exchange estimate May 2026",
    flags: ["Below asking", "Solicitor not instructed", "No POF"],
    notes: "Speculative offer pending sale of own property.",
    aiVerdict: "Lowest certainty — recommend decline or counter",
  },
];

export const aiVerdict = {
  recommended: "o-001",
  recommendedBuyer: "Akari Tanaka",
  recommendedOffer: "£620,000",
  reason: "Net realisable value highest after 9% probability-weighted fall-through and 27-day average completion gain.",
  weightedValue: "£596,720",
  exchangeProb: 91,
  insights: [
    {
      tone: "low",
      title: "Best overall buyer despite lower offer",
      detail: "Tanaka's cash position and verified funds raise risk-adjusted yield 4.1% above the highest headline offer.",
    },
    {
      tone: "low",
      title: "Highest likelihood of successful completion",
      detail: "Chandra and Tanaka both >88% modelled completion rate — both well above network mean of 76%.",
    },
    {
      tone: "med",
      title: "Increased risk due to dependent chain",
      detail: "Bellingham's onward sale in St Albans is mid-search — chain failure adds 18% fall-through probability.",
    },
    {
      tone: "low",
      title: "Fastest projected route to exchange",
      detail: "Tanaka 21d vs network mean 41d. Vendor cash-flow benefit £4,200 (interest opportunity).",
    },
    {
      tone: "high",
      title: "Negotiation leverage available",
      detail: "Greaves' offer is structurally weak — recommend formal decline; signal scarcity to elevate Bellingham response.",
    },
  ],
  factors: [
    { label: "Financial reliability", weight: 22, score: 91 },
    { label: "Chain complexity", weight: 18, score: 84 },
    { label: "Speed to exchange", weight: 16, score: 88 },
    { label: "Documentation ready", weight: 14, score: 85 },
    { label: "Buyer motivation", weight: 12, score: 79 },
    { label: "Headline price", weight: 10, score: 72 },
    { label: "Solicitor readiness", weight: 8, score: 80 },
  ],
};

export const market = {
  demandScore: 82,
  viewingsToOffer: 14.8, // %
  competing: 9, // active competing buyers in postcode
  pricingConfidence: 91,
  comparables: [
    { addr: "Apt 18, Riverlight Quay", price: "£618k", days: 9, status: "Exchanged" },
    { addr: "Apt 22, Tower One", price: "£635k", days: 14, status: "STC" },
    { addr: "Apt 4, Bermondsey Wks", price: "£605k", days: 19, status: "Exchanged" },
    { addr: "Apt 31, Riverlight Quay", price: "£642k", days: 7, status: "Listed" },
  ],
  heat: [
    [3, 5, 8, 11, 14, 9, 6],
    [5, 9, 14, 18, 22, 14, 8],
    [4, 7, 12, 16, 19, 11, 6],
    [2, 4, 6, 8, 10, 6, 3],
  ],
  intelligence: [
    "Postcode demand index up 12% MoM, driven by relocation activity from Battersea Power Station phase 2.",
    "Comparable apt Apt 22, Tower One sold £10K above ask in 14 days — list price aligned with current £/sqft band.",
    "9 active competing buyers in SW11 within £580k–£650k bracket — scarcity supports strong negotiation position.",
  ],
};
